import { isGeoJSONFeature } from '@tmapy/types';
import { isArray, isNumberOrString } from '../../utils/baseAssert';
import { LAYER_TYPE } from '../../constants';
/**
 * TODO: Claim is **very weak**, needs clarification!
 */
export const isVectorLayerState = (layerState) => {
    if (!layerState) {
        return false;
    }
    const isTypeLayerState = layerState.type === LAYER_TYPE.VECTOR;
    const highlightedFeatureIds = layerState.highlightedFeatureIds;
    const hasHighlightedFeatureIds = isArray(highlightedFeatureIds) && highlightedFeatureIds.every(isNumberOrString);
    const hasSourceOptions = !!layerState?.sourceOptions; // TODO add isVectorSourceConfig
    const features = layerState.features;
    const hasFeatures = isArray(features) && features.every(isGeoJSONFeature);
    return isTypeLayerState && hasFeatures && hasSourceOptions && hasHighlightedFeatureIds;
};
//# sourceMappingURL=layers.js.map